export const ActionTypes = {
  LOADING: "GET_MINIMAL_DECISION_INFO_LOADING",
  ERROR: "GET_MINIMAL_DECISION_INFO_ERROR",
  SUCCESS: "GET_MINIMAL_DECISION_INFO_SUCCESS",
  SET_MINIMAL_DECISION: "SET_MINIMAL_DECISION",
  DELETE_MINIMAL_DECISION: "DELETE_MINIMAL_DECISION",
};
